import React, { createContext, useContext, useState, useCallback } from 'react';
import ConfirmModal from '../components/shared/ConfirmModal';

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [confirmConfig, setConfirmConfig] = useState(null);

  const confirm = useCallback((config) => {
    return new Promise((resolve) => {
      setConfirmConfig({
        ...config,
        onConfirm: () => {
          setConfirmConfig(null);
          resolve(true);
        },
        onCancel: () => {
          setConfirmConfig(null);
          resolve(false);
        },
      });
    });
  }, []);

  return (
    <ModalContext.Provider value={{ confirm }}>
      {children}
      {confirmConfig && (
        <ConfirmModal
          isOpen={!!confirmConfig}
          title={confirmConfig.title || 'Are you sure?'}
          message={confirmConfig.message}
          confirmText={confirmConfig.confirmText || 'Confirm'}
          cancelText={confirmConfig.cancelText || 'Cancel'}
          onConfirm={confirmConfig.onConfirm}
          onCancel={confirmConfig.onCancel}
          type={confirmConfig.type || 'warning'}
        />
      )}
    </ModalContext.Provider>
  );
};

export const useConfirm = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useConfirm must be used within a ModalProvider');
  }
  return context.confirm;
};
